import { render, staticRenderFns } from "./ChatRight.vue?vue&type=template&id=57c92e93&scoped=true&"
import script from "./ChatRight.vue?vue&type=script&lang=js&"
export * from "./ChatRight.vue?vue&type=script&lang=js&"
import style0 from "./ChatRight.vue?vue&type=style&index=0&id=57c92e93&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57c92e93",
  null
  
)

export default component.exports